import { COMMON_TEXT } from "@/constants/text";
import { getPrinterCodeByUserWithWhoami } from "@/utils/checkAuth";
import { customNotification } from "@/utils/notificationShow";
import axios from "axios";

interface useBarcodePrintHandlerProps {
  lotName: string[] | undefined;
  itemCode: string[] | undefined;
  locationCode: string[] | undefined;
}

export const useBarcodePrintHandler = ({
  lotName,
  locationCode,
  itemCode,
}: useBarcodePrintHandlerProps) => {
  const lot_name = lotName;
  const location_code = locationCode;
  const item_code = itemCode;

  const onSubmit = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_COMPANY_BARCODE_ADDRESS_INVENTORY}`,
        {
          company_code: process.env.REACT_APP_COMPANY_CODE,
          lot_name: lot_name,
          printer_code: await getPrinterCodeByUserWithWhoami(),
          quantity: 1, // 몇 장 뽑을 것인지에 대한 quantity 정보
          location_code: location_code,
          item_code: item_code,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      customNotification.error({
        message: COMMON_TEXT.NOTIFICATION.BARCODE_PRINT_FAIL,
      });
      return false;
    }
  };

  return { onSubmit };
};
